module.exports = __webpack_public_path__ + "static/media/avataaars (2).fe8026bf.svg";